import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/printPreview',
        name: 'printPreview',
        component: () => import("./views/printPreview.vue"),
        meta: {
            hideHelpButton: true
        }
    },
];

export default routes;
